import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CredentialState {
  phone?: string;
  verificationId?: string;
  initialIdToken?: string;
  idToken?: string;
  nationCode?: string;
  isOwner?: boolean;
}

const initialState: CredentialState = {
  isOwner: false,
};

const credentialSlice = createSlice({
  name: "credential",
  initialState: initialState,
  reducers: {
    saveCredential: (state, action: PayloadAction<CredentialState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    changeVerificationUser: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isOwner: action.payload,
      };
    },
    clearIdToken: (state) => {
      return {
        ...state,
        idToken: "",
      };
    },
    clearCredential: () => {
      return initialState;
    },
  },
});

export const { saveCredential, changeVerificationUser, clearIdToken, clearCredential } = credentialSlice.actions;

export default credentialSlice.reducer;
